import axios from "axios";
import swal from "sweetalert2";
import parse from "html-react-parser";

import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { accessTokenKey, baseUrl } from "../utils/config";

import Loader from "./layouts/Loader";

function EditJob() {

    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const [job, setJob] = useState([]);
    const [categories, setCategories] = useState([]);

    async function updateJob() {
        setEditing(true);

        try {
            const form = document.getElementById("form-update-job");
            const formData = new FormData(form);
            formData.append("id", id);

            const response = await axios.post(
                baseUrl + "/api/jobs/update",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                swal.fire("Update Job", response.data.message, "info");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setEditing(false);
        }
    }

    async function fetchJob() {
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append("id", id);

            const response = await axios.post(
                baseUrl + "/api/jobs/fetch-single",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setJob(response.data.job);
                setCategories(response.data.categories);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(function () {
        fetchJob();
    }, []);

    const styles = {
        description: {
            height: "150px"
        },
        bgWhite: {
            backgroundColor: "white"
        }
    };

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Edit Job</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/my">My Jobs</Link></li>
                            <li className="breadcrumb-item text-white" aria-current="page">Edit</li>
                            <li className="breadcrumb-item text-white active" aria-current="page">{ id }</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Edit Job</h1>
                    <div className="row g-4">
                        <div className="col-md-12">
                            <div className="wow fadeInUp" data-wow-delay="0.5s">

                                { loading && (
                                    <div className="text-center mb-5">
                                        <Loader />
                                    </div>
                                ) }

                                <p className="mb-4">Create and publish job listings to attract potential candidates. The listing becomes visible to job seekers, enabling them to apply directly. It simplifies the hiring process for companies.</p>

                                { job != null && (
                                    <form onSubmit={ function (event) {
                                        event.preventDefault();
                                        updateJob();
                                    } } id="form-update-job">
                                        <div className="row g-3">

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input type="text" className="form-control" name="title" placeholder="Job Title" required
                                                        defaultValue={ job.title } />
                                                    <label>Job Title</label>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <select name="type" className="form-control"
                                                        value={ job.type }
                                                        onChange={ function (event) {
                                                            const temp = { ...job };
                                                            temp.type = event.target.value;
                                                            setJob(temp);
                                                        } }
                                                        style={ styles.bgWhite }>
                                                        <option value="remote">Remote</option>
                                                        <option value="on_site">On-site</option>
                                                        <option value="hybrid">Hybrid</option>
                                                    </select>
                                                    <label>Type</label>
                                                </div>
                                            </div>

                                            { ["on_site", "hybrid"].includes(job.type) && (
                                                <div className="col-md-6">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" name="location" placeholder="Location"
                                                            defaultValue={ job.location } />
                                                        <label>Location</label>
                                                    </div>
                                                </div>
                                            ) }

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <select name="category" className="form-control"
                                                        style={ styles.bgWhite }
                                                        value={ job.category }
                                                        onChange={ function (event) {
                                                            const temp = { ...job };
                                                            temp.category = event.target.value;
                                                            setJob(temp);
                                                        } }>
                                                        <option value="">Select Category</option>

                                                        { categories.map(function (category, index) {
                                                            return (
                                                                <option key={ `category-${ index }` }
                                                                value={ category.category }>{ category.category }</option>
                                                            );
                                                        }) }
                                                    </select>
                                                    <label>Category</label>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <select name="nature" className="form-control"
                                                        value={ job.nature }
                                                        onChange={ function (event) {
                                                            const temp = { ...job };
                                                            temp.nature = event.target.value;
                                                            setJob(temp);
                                                        } }
                                                        style={ styles.bgWhite }>
                                                        <option value="full_time">Full-time</option>
                                                        <option value="part_time">Part-time</option>
                                                    </select>
                                                    <label>Job Nature</label>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input type="text" className="form-control" name="currency" placeholder="Currency"
                                                        defaultValue={ job.currency } />
                                                    <label>Currency</label>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input type="number" min="0" className="form-control" name="salary_from" placeholder="From"
                                                        defaultValue={ job.salary_from } />
                                                    <label>Salary From</label>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input type="number" min="0" className="form-control" name="salary_to" placeholder="To"
                                                        defaultValue={ job.salary_to } />
                                                    <label>Salary To</label>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <input type="number" min="1" className="form-control"
                                                        name="vacancies"
                                                        defaultValue={ job.vacancies }
                                                        placeholder="Vacancies" />
                                                    <label>Vacancies</label>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <textarea name="description" className="form-control"
                                                        style={ styles.description }
                                                        defaultValue={ job.description || "" }></textarea>
                                                    <label>Description</label>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-floating">
                                                    <select name="status" className="form-control"
                                                        value={ job.status }
                                                        style={ styles.bgWhite }
                                                        onChange={ function (event) {
                                                            const temp = { ...job };
                                                            temp.status = event.target.value;
                                                            setJob(temp);
                                                        } }>
                                                        <option value="active">Active</option>
                                                        <option value="in_active">In-active</option>
                                                    </select>
                                                    <label>Status</label>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <button className="btn btn-warning w-100 py-3" type="submit"
                                                    disabled={ editing }>Update Job</button>
                                            </div>
                                        </div>
                                    </form>
                                ) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditJob;